import { FilterOperator, CLOUD_ASSET_TABLE_NAME } from 'shared/base';

import { AssetInventorySidebarFilterFieldEnum } from '../../constants/sidebar';
import {
  conditionallyWrapValue,
  getValueFromString,
  setKeyValuesOnString,
} from '../../utils/tableState';

import { useTableStateContext } from '../useTableStateContext';

import { UseSidebarFilterResponse } from './types';

export const useSidebarFilter = (): UseSidebarFilterResponse => {
  const { filter, overwriteFilter, tableName } = useTableStateContext();

  const resourceType = tableName === CLOUD_ASSET_TABLE_NAME ? undefined : tableName;

  const resourceCategory = getValueFromString(
    filter,
    AssetInventorySidebarFilterFieldEnum.resource_category,
  );

  const removeResourceCategory = () => {
    overwriteFilter(
      setKeyValuesOnString(filter, [
        [AssetInventorySidebarFilterFieldEnum.resource_category, undefined],
      ]),
    );
  };

  const setResourceCategoryToAll = () => {
    overwriteFilter(
      setKeyValuesOnString('', [
        [AssetInventorySidebarFilterFieldEnum.resource_category, '""', FilterOperator.notEqual],
        [AssetInventorySidebarFilterFieldEnum.resource_type, undefined],
      ]),
    );
  };

  const setResourceType = (type?: string) => {
    overwriteFilter(
      setKeyValuesOnString(filter, [
        [AssetInventorySidebarFilterFieldEnum.resource_category, undefined],
        [
          AssetInventorySidebarFilterFieldEnum.resource_type,
          type ? conditionallyWrapValue(type) : undefined,
        ],
      ]),
    );
  };

  const setResourceCategory = (value?: string) => {
    overwriteFilter(
      setKeyValuesOnString(filter, [
        [
          AssetInventorySidebarFilterFieldEnum.resource_category,
          value ? conditionallyWrapValue(value) : undefined,
        ],
        [AssetInventorySidebarFilterFieldEnum.resource_type, undefined],
      ]),
    );
  };

  return {
    removeResourceCategory,
    resourceCategory,
    resourceType,
    setResourceCategory,
    setResourceCategoryToAll,
    setResourceType,
  };
};
